export default "__VITE_ASSET__BqDnXAiN__"